import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { theme } from 'antd';
import type {
  PositionDetailOut,
  PublicationListOut,
} from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { POSITION_DEFAULT_TAB, POSITION_SHOW_TABS } from '../constants';
import { PositionShowHeader } from './PositionShowHeader';
import { PositionGeneralTab } from './PositionGeneralTab';

export const PositionShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<PositionDetailOut>({
    resource: 'progress.positions',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  useRecordDocumentTitle(
    'progress.positions',
    record && (publication?.title ?? `#${record.id}`)
  );

  const [activeTab, onTabChange] = useShowTab(
    POSITION_SHOW_TABS,
    POSITION_DEFAULT_TAB
  );

  return (
    <Show isLoading={isLoading} contentProps={bareShowContentProps}>
      {record && (
        <>
          <PositionShowHeader
            record={record}
            publication={publication}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <PositionGeneralTab record={record} publication={publication} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
